export const newsPage = {
  seo: {
    title: "最新消息｜來加綉綉紅豆餅活動、口味與宅配公告",
    description:
      "掌握來加綉綉紅豆餅最新口味、冷凍宅配、禮盒預購、加盟說明會、市集活動與品牌公告。",
  },
  hero: {
    tag: "最新消息",
    title: "最新消息",
    subtitle:
      "新口味、宅配預購、市集活動、加盟說明會，來加綉綉的最新動態都在這裡。",
  },
  categories: [
    { id: "all", label: "全部消息" },
    { id: "new-flavor", label: "新口味上市" },
    { id: "delivery", label: "宅配與禮盒" },
    { id: "market", label: "市集活動" },
    { id: "franchise", label: "加盟說明會" },
    { id: "brand", label: "品牌公告" },
  ],
  articles: [
    {
      id: 1,
      category: "new-flavor",
      categoryLabel: "新口味上市",
      title: "季節限定口味開賣｜這一季的甜，剛剛好",
      summary:
        "依季節推出限定內餡，讓熟客每次回訪都有新期待。",
    },
    {
      id: 2,
      category: "delivery",
      categoryLabel: "宅配與禮盒",
      title: "冷凍宅配正式開放預購",
      summary:
        "在家回烤也能享受來加綉綉的香氣，適合家庭、辦公室與團購。",
    },
    {
      id: 3,
      category: "delivery",
      categoryLabel: "宅配與禮盒",
      title: "企業下午茶與節慶禮盒洽詢開放",
      summary:
        "適合公司點心、活動贈禮、節慶分享與團體訂購。",
    },
    {
      id: 4,
      category: "market",
      categoryLabel: "市集活動",
      title: "來加綉綉市集出攤資訊",
      summary:
        "歡迎到現場品嚐剛出爐的紅豆餅，感受現烤香氣。",
    },
    {
      id: 5,
      category: "franchise",
      categoryLabel: "加盟說明會",
      title: "加盟說明會預約開放",
      summary:
        "想了解紅豆餅副業、擺攤、市集或店面經營者，歡迎預約諮詢。",
    },
    {
      id: 6,
      category: "brand",
      categoryLabel: "品牌公告",
      title: "品牌官網正式上線",
      summary:
        "從產品、宅配到加盟合作，來加綉綉的完整資訊正式公開。",
    },
  ],
};